// javascript
import React, { useState } from 'react';
import api from '../../../helper/util/api';
// import PropertyOwnerList from './PropertyOwnerList';

export default function DocketRow({ data = null, onUploaded, onCancel }) {
  // initial: if provided, it's an existing docket object and this component will render a readonly view.
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [owners, setOwners] = useState([]);

  // for creating new docket we expect caller to pass dealId when calling upload
  async function handleUpload(dealId) {
    if (!file) return alert('Please choose a file');
    setLoading(true);
    const newOwners = owners.filter(r => r.isNew);
    try {
      const form = new FormData();
      form.append('docketFile', file);
      // form.append('is_virtual_tour', isVirtual ? 'true' : 'false');
      form.append('owners', JSON.stringify(newOwners));
      const res = await api.post(`/deals/${dealId}/dockets`, form); //, { headers: { 'Content-Type': 'multipart/form-data' } }
      onUploaded && onUploaded(res.data);
    } catch (err) {
      console.error(err);
      alert('Upload failed');
    } finally {
      setLoading(false);
    }
  }


  if (data) {
    return (
      <div className='docket-list'>
        <div className="list-item">
          <div>
            <div className="meta">{data.file_url ? <a href={data.file_url} target="_blank" rel="noreferrer">Open docket</a> : 'No File'}</div>
            {/* <div className="small-muted">{data.is_virtual_tour ? 'Virtual tour' : 'Physical'}</div> */}
          </div>
          <div className="meta">{new Date(data.created_at).toLocaleString()}</div>
        </div>
        {/* {
          data.owners.length > 0 && (
            <div>
              <PropertyOwnerList owners={data.owners} showAction={false} />
            </div>
          )
        } */}
      </div>
    );
  }

  // new row UI
  return (
    <div className="new-row">
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 8 }}>
        <div style={{maxWidth: '300px'}}>
          <input className="file-input" type="file" onChange={e => setFile(e.target.files?.[0] || null)} style={{width:'100%'}} 
            accept="image/*, application/pdf, .pdf, .jpg, .jpeg, .png" 
            />
        </div>
        {/* <div>
          <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <input type="checkbox" checked={isVirtual} onChange={e => setIsVirtual(e.target.checked)} />
            <span className="small-muted">Is virtual tour</span>
          </label>
        </div> */}
      </div>
      {/* <div>
        <PropertyOwnerList owners={owners} setOwners={setOwners}  />
      </div> */}
      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
        <button className="btn-small ghost" onClick={onCancel} type="button">Cancel</button>
        <button className="btn-small" onClick={() => handleUpload(window.__CURRENT_DEAL_ID__)} disabled={loading}>
          {loading ? 'Uploading...' : 'Upload'}
        </button>
      </div>
    </div>
  );
}
